import { Controller } from "@hotwired/stimulus";
import posthog from "posthog-js";

export default class extends Controller {
  static values = {
    apiKey: String,
    apiHost: String,
  };

  connect() {
    this.initializePostHog();
  }

  initializePostHog() {
    if (this.apiKeyValue && this.apiHostValue) {
      posthog.init(this.apiKeyValue, {
        api_host: this.apiHostValue,
        defaults: "2025-05-24",
        enable_recording_console_log: true,
      });
    }
  }
}
